import React, { useRef } from 'react';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/material/styles';

import './AIBanner.css';
import { useMediaQuery, useTheme } from '@mui/material';

type AIBannerProps = {
  sx?: SxProps;
  variant?: 'minimal' | 'small' | 'normal' | undefined;
};

const AIBanner: React.FC<AIBannerProps> = (props: AIBannerProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { sx = {}, variant = isMobile ? 'small' : 'normal' } = props;
  const aibannerRef = useRef<HTMLElement | null>(null);

  return (
    <Box sx={sx} className="aibanner-clipper">
      <Box ref={aibannerRef} className={` aibanner-label-${variant} aibanner-label`}>
        <Box>AI Generated</Box>
      </Box>
    </Box>
  );
};

export { AIBanner };
